import React from "react"
import HtmlContent from './HtmlContent'
import SourcesList from './SourcesList'
import ScrollTop from './ScrollTop'
import CategoriesList from './CategoriesList'
import DateValue from './DateValue'
import StaticHtml from '../components/StaticHtml'
import cs from 'classnames'
import styles from './news.scss'

export const Footer = ({sourceIds, categoryIds}) => {
	return (
		<div className={styles.footer}>
			{sourceIds.length > 0 &&
				<SourcesList sourceIds={sourceIds}/>
			}
			<div className={styles.divide}/>
			<CategoriesList categoryIds={categoryIds}/>
		</div>
	)
}

export const Overlay = ({children}) => (
	<div className={styles.overlayCont}>
		<div className={styles.overlay}/>
		{children}
	</div>
)

export const NewsContentDom = ({title, content, teaser, date, sourceIds, categoryIds, className}) => {
	return (
		<ScrollTop className={cs(className, styles.newsContainer)}>
			<div className={styles.newsCenter}>
				<h2 className={styles.title}>{title}</h2>
				{date && <DateValue className={styles.pubDate} date={date}/>}
				{content !== "PREVIEW" && <HtmlContent className={styles.content} content={content}/>}
				{teaser &&
					<Overlay>
						<HtmlContent className={styles.teaser} content={teaser}/>
					</Overlay>
				}
				{teaser && <StaticHtml className={styles.cta} id="callToAction"/>}
				{content && categoryIds && sourceIds &&
					<Footer
						categoryIds={categoryIds}
						sourceIds={sourceIds}
					/>
				}
			</div>
		</ScrollTop>
	)
}

const NewsContent = ({item, className}) => {
	const {title, content, pubStart: date, sourceIds, categoryIds} = item
	const teaser = content === "PREVIEW" && item.teaser
	return (
		<NewsContentDom
			{...{
				categoryIds,
				content,
				date,
				sourceIds,
				title,
				className,
				teaser,
			}}
		/>
	)
}
export default NewsContent



// WEBPACK FOOTER //
// ./elements/NewsContent.jsx